import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Placeholder from '../../../components/Placeholder';
import { reducer, state } from '../../../redux/sagas/aws-cognito-redux-saga';

import {
  Anchor,
  Button,
  ButtonPlaceholder,
  Input,
  InputRow,
  InputError,
  PageContent,
  Subtitle,
  SubtitlePlaceholder,
  Text,
  Title,
  Wrapper,
  Spinner,
} from './ForgotPasswordPage.style';
import { TABLET_P } from '../../../constants';

class ForgotPasswordPage extends Component {
  state = {
    email: '',
    loading: false,
    error: '',
    formDirty: false,
  };

  componentWillMount() {
    this.props.init();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.auth.hasSentCode === state.AUTH_UNKNOWN && nextProps.auth.hasSentCode === state.AUTH_SUCCESS) {
      this.setState({
        loading: false,
        error: '',
      });
    } else if (nextProps.auth.error.message && this.state.formDirty) {
      const { copy } = this.props;
      this.setState({
        loading: false,
        error:
          (copy.errorMessage && copy.errorMessage.unRegisteredEmail && copy.errorMessage.unRegisteredEmail) ||
          nextProps.auth.error.message || 'Error',
      });
    }
  }

  handleForgotPassword = e => {
    e.preventDefault();
    const { forgotPassword } = this.props;
    const { email } = this.state;
    if (this.validateForm()) {
      this.setState(
        {
          loading: true,
          formDirty: true,
        },
        () => {
          forgotPassword(email.toLowerCase());
        }
      );
    }
  };

  validateForm = () => {
    const { copy } = this.props;
    const { email } = this.state;
    if (email === '') {
      this.setState({
        loading: false,
        error: (copy.errorMessage && copy.errorMessage.notEnteredEmail && copy.errorMessage.notEnteredEmail) || 'Error',
      });
      return false;
    }
    this.setState({
      loading: false,
      error: '',
    });
    return true;
  };

  handleChangePassword = e => {
    e.preventDefault();
    const { history, locale } = this.props;
    history.push(`/${locale}/salon-consultation/change-password`);
  };

  handleEmailChange = e =>
    this.setState(
      {
        email: e.target.value,
      },
      () => {
        this.validateForm();
      }
    );

  render() {
    const { locale, copy, auth } = this.props;
    const { email, loading, error } = this.state;
    const copyf = (copy.forgotPassword && copy.forgotPassword) || {};
    return (
      <Wrapper>
        <PageContent>
          {Object.keys(copyf).length !== 0 && copyf.constructor === Object ? (
            <Title>{copyf.forgotYourPassword}</Title>
          ) : (
            <Placeholder h="40px" w={window.innerWidth > TABLET_P ? '500px' : '100%'} />
          )}
          {Object.keys(copyf).length !== 0 && copyf.constructor === Object ? (
            <Subtitle>{copyf.emailYouInstructions}</Subtitle>
          ) : (
            <SubtitlePlaceholder>
              <Placeholder h="24px" w={window.innerWidth > TABLET_P ? '400px' : '100%'} />
            </SubtitlePlaceholder>
          )}
          <form
            onSubmit={auth.hasSentCode !== state.AUTH_SUCCESS ? this.handleForgotPassword : this.handleChangePassword}
          >
            <InputRow>
              <Input
                type="email"
                placeholder={copyf.emailPlaceholder}
                value={email}
                onChange={this.handleEmailChange}
                className={error ? 'has-error' : ''}
              />
              <InputError>{error}</InputError>
            </InputRow>
            {Object.keys(copyf).length !== 0 && copyf.constructor === Object ? (
              <Button type="submit" disabled={loading}>
                {loading ? (
                  <Spinner />
                ) : auth.hasSentCode !== state.AUTH_SUCCESS ? (
                  copyf.sendCode
                ) : (
                  copyf.changePassword
                )}
              </Button>
            ) : (
              <ButtonPlaceholder>
                <Placeholder h="65px" w={window.innerWidth > TABLET_P ? '300px' : '100%'} />
              </ButtonPlaceholder>
            )}
          </form>
          {Object.keys(copyf).length !== 0 && copyf.constructor === Object ? (
            <React.Fragment>
              <Text>{copyf.alreadyHaveAccount}</Text>
              <Link to={`/${locale}/salon-consultation/login`} href={`/${locale}/salon-consultation/login`}>
                <Anchor>{copyf.signIn}</Anchor>
              </Link>
            </React.Fragment>
          ) : (
            <Placeholder h="25px" w="250px" />
          )}
        </PageContent>
      </Wrapper>
    );
  }
}

ForgotPasswordPage.defaultProps = {
  copy: {},
};

ForgotPasswordPage.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  auth: PropTypes.shape({
    hasSentCode: PropTypes.string,
    error: PropTypes.shape({}),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  forgotPassword: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
};

const mapState = state => ({
  // copy: state.siteOptions.siteCopyStylistToolForgotPasswordPage,
  copy: state.salonConsultaionSiteOptions.siteCopy,
  locale: state.locale,
  auth: state.auth,
});

const mapDispatch = dispatch => ({
  forgotPassword: username => dispatch(reducer.forgotPassword(username)),
  init: () => dispatch(reducer.init()),
});

export default connect(mapState, mapDispatch)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/ForgotPasswordPage/ForgotPasswordPage.js